import { countryConfig } from '../../../country';
import { CL_OPERATOR } from '../cl/operator';

/**
 * AI CRM Inc's Delaware file number (Division of Corporations) — supplied by the
 * owner on 2026-10-20. One constant for the aviso legal and the JSON-LD.
 */
export const ES_OPERATOR_FILE_NUMBER = '10163511';

/** = `brand.supportEmail` of the es country config (fixed decision, AGENT-RULES §6). */
const ES_OPERATOR_EMAIL = 'support@milicita.es';

/**
 * Who operates MiLicita, as the Spanish legal set states it. Facts supplied by
 * the owner's brief (2026-10-19) — the card payee of the KZ edition, AI CRM Inc —
 * and his data and decisions of 2026-10-20/21 (registry number; no EIN published,
 * the company is identified by name, Delaware address and Delaware registry
 * number; no EU representative is named), nothing else. Never fill a gap with a
 * plausible-looking guess.
 */
const ES_SPAIN_OPERATOR = {
  name: 'AI CRM Inc',
  address: '251 Little Falls Drive, Wilmington, New Castle County, DE 19808, Estados Unidos',
  brand: 'MiLicita',
  site: 'https://milicita.es',
  host: 'milicita.es',
  email: ES_OPERATOR_EMAIL,
  registry: `sociedad constituida en el Estado de Delaware (Estados Unidos), inscrita en la Division of Corporations del Delaware Department of State con el número de registro (file number) ${ES_OPERATOR_FILE_NUMBER}`,
  // Owner, 2026-10-21: no EIN is published — the company is identified by its
  // Delaware registry number.
  identification: `AI CRM Inc., sociedad constituida en Delaware (EE. UU.), número de registro ${ES_OPERATOR_FILE_NUMBER}`,
} as const;

/**
 * The operator the app names (footer, /about, JSON-LD, the legal pages): Spain's
 * above, or on Chile the same company with Liciora's brand, site and address
 * (`content/legal/cl/operator.ts`). The JSON-LD identifier and postal address
 * below are the same facts on both.
 */
export const ES_OPERATOR: typeof ES_SPAIN_OPERATOR | typeof CL_OPERATOR =
  countryConfig.code === 'cl' ? CL_OPERATOR : ES_SPAIN_OPERATOR;

/**
 * The aviso legal's «Datos registrales» as a schema.org `identifier` for the
 * sitewide Organization node: the Delaware file number, checkable against the
 * state register. Not a `taxID` — no EIN is published (owner, 2026-10-21).
 */
export const ES_OPERATOR_IDENTIFIER = {
  '@type': 'PropertyValue',
  propertyID: 'Delaware Division of Corporations file number',
  value: ES_OPERATOR_FILE_NUMBER,
} as const;

/**
 * {@link ES_OPERATOR}'s address as a schema.org `PostalAddress` — the JSON-LD
 * twin of the aviso legal's «Domicilio», for the sitewide Organization node.
 * The same facts split into fields (`es-legal.test.ts` pins each one against
 * the published address). No tax id goes into the JSON-LD: none is published.
 */
export const ES_OPERATOR_POSTAL_ADDRESS = {
  '@type': 'PostalAddress',
  streetAddress: '251 Little Falls Drive',
  addressLocality: 'Wilmington',
  addressRegion: 'DE',
  postalCode: '19808',
  addressCountry: 'US',
} as const;
